module.exports = __webpack_public_path__ + "img/Pitney_Bowes_2015.5b4d969c.svg";